import React from 'react';
import ModalFormUI from '../../../widgets/form/ModalFormUI';
import InputTextSF from '../../../widgets/form/InputTextSF';
import SpinnerComponentUI from "../../../components/common/SpinnerComponentUI";

const VendorDiligenceCreateModalUI = ({ 
  context, 
  successMsg, 
  errorList, 
  setErrorList, 
  messageList,
  createMode,
  onSubmit, 
  onCancelClick,
  companyName, 
  onCompanyNameChange, 
  companyNameError, 
  setCompanyNameError,
  isSubmitting
}) => (
  <ModalFormUI
    context={context}
    titleLabel='Add New Vendor Diligence'
    buttonLabel={isSubmitting ? 'Processing...' : 'Submit'}
    cancelLabel='Cancel'
    isOpen={createMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    submitDisabled={isSubmitting}
    submitIcon={isSubmitting ? <SpinnerComponentUI context={context} size="small" /> : null}
  >
    <InputTextSF 
      type='text' 
      name='companyName' 
      maxLength={100}
      label='Company Name'
      value={companyName} 
      onChange={onCompanyNameChange}
      error={companyNameError} 
      setError={setCompanyNameError}
      autoFocus={true}
      disabled={isSubmitting}
    />
    
    {isSubmitting && (
      <div className="g_text_center g_m_top_20">
        <p>Processing your request...</p>
        <div className="g_m_top_10">
          <SpinnerComponentUI context={context} />
        </div>
      </div>
    )}
  </ModalFormUI>
);

export default VendorDiligenceCreateModalUI;